import { useProfile } from "@/context/useProfileProps";
import { handleFocusOnField } from "@/helpers/helper";
import { useEffect, useRef, useState } from "react";

import ProfileModal from "@/components/common/profileModal";
import { delRefType } from "@/components/profile/types";

import WorkFields from "./components/workFields";
import { EditProps, WorkExpLoadingTypes } from "./types";

const EditCard = ({
  isEdit,
  closeEdit,
  totalEmployments = 0,
  prefilledData = null,
  isCalledFromOutside = false,
  formRef,
  handleFooterBtnLoading,
  focusOnField = "",
}: EditProps) => {
  const [loading, setLoading] = useState({
    isSaveLoading: false,
    isDeleteLoading: false,
  });
  const delRef = useRef<delRefType>(null);
  const {
    isMobile,
    translation: { workExperience },
  } = useProfile();

  const handleLoading = (e: WorkExpLoadingTypes) => {
    setLoading((prev) => ({ ...prev, ...e }));
    if (e.isSaveLoading !== undefined && handleFooterBtnLoading) {
      handleFooterBtnLoading({ isSaveLoading: e.isSaveLoading });
    }
  };

  useEffect(() => {
    if (focusOnField) {
      handleFocusOnField(focusOnField);
    } else {
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);
      const focusField = params.get("focusOnField");
      setTimeout(() => {
        focusField && handleFocusOnField(focusField);
      }, 500);
    }
  }, [focusOnField]);

  const renderForm = (
    <WorkFields
      handleLoading={handleLoading}
      prefilledData={prefilledData}
      closeEdit={closeEdit}
      formRef={formRef}
      delRef={delRef}
    />
  );

  return !isCalledFromOutside ? (
    <ProfileModal
      heading={prefilledData ? workExperience.editWork : workExperience.addWork}
      showModal={isEdit}
      closeModal={closeEdit}
      isMobile={isMobile}
      showCloseButton={true}
      screenAlignment={isMobile ? "bottom-sheet" : "center"}
      showHandleBar={true}
      footerPrimaryBtnLabel="Save"
      footerPrimaryBtnHandler={() => formRef.current?.requestSubmit()}
      footerSecondaryBtnLabel={
        prefilledData && !prefilledData?.employmentPrefill?.isAutoUpdated
          ? "Delete Experience"
          : ""
      }
      footerSecondaryBtnHandler={() => delRef.current?.handleDelete()}
      footerPrimaryBtnIsLoading={loading.isSaveLoading}
      footerSecondaryBtnIsLoading={loading.isDeleteLoading}
    >
      {renderForm}
    </ProfileModal>
  ) : (
    renderForm
  );
};

export default EditCard;
